import type { ComponentProps } from 'node_modules/@types/react';
import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ChartEditorContainer } from './chartEditor.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChartsEdit: ComponentProps<typeof ChartEditorContainer>;
  }
}
modalRenderer.register('ChartsEdit', ChartEditorContainer);
